export default __webpack_public_path__ + "static/media/mrw-canje.8b7080a6.svg";